import {yupResolver} from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';
import {Button, Grid} from '@mui/material';
import React, {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {i18n} from 'src/i18n';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import Storage from 'src/security/storage';
import CategoriaProductoAutocompleteFormItem from 'src/view/categoriaProducto/autocomplete/CategoriaProductoAutocompleteFormItem';
import ImagesFormItem from 'src/view/shared/form/items/ImagesFormItem';
import InputFormItem from 'src/view/shared/form/items/InputFormItem';
import FormWrapper, {FormButtons} from 'src/view/shared/styles/FormWrapper';
import * as yup from 'yup';

const schema = yup.object().shape({
  foto: yupFormSchemas.images(i18n('entities.producto.fields.foto'), {
    required: false,
  }),
  productoCompleto: yupFormSchemas.string(i18n('entities.producto.fields.productoCompleto'), {
    required: true,
  }),
  codBarra: yupFormSchemas.string(i18n('entities.producto.fields.codBarra'), {}),
  codGrupo: yupFormSchemas.string(i18n('entities.producto.fields.codGrupo'), {}),
  codProd: yupFormSchemas.string(i18n('entities.producto.fields.codProd'), {}),
  codRapido: yupFormSchemas.string(i18n('entities.producto.fields.codRapido'), {}),
  codSubGr: yupFormSchemas.string(i18n('entities.producto.fields.codSubGr'), {}),
  codUMed: yupFormSchemas.string(i18n('entities.producto.fields.codUMed'), {}),
  desProd: yupFormSchemas.string(i18n('entities.producto.fields.desProd'), {}),
  desProd2: yupFormSchemas.string(i18n('entities.producto.fields.desProd2'), {}),
  precioBol: yupFormSchemas.string(i18n('entities.producto.fields.precioBol'), {}),
  precioVta: yupFormSchemas.string(i18n('entities.producto.fields.precioVta'), {}),
  ean13: yupFormSchemas.string(i18n('entities.producto.fields.ean13'), {}),
  sku: yupFormSchemas.string(i18n('entities.producto.fields.sku'), {}),
  imgUrl: yupFormSchemas.string(i18n('entities.producto.fields.imgUrl'), {}),
  categorias: yupFormSchemas.relationToMany(i18n('entities.producto.fields.categorias'), {}),
});

function ProductoForm(props) {
  const [initialValues] = useState(() => {
    const record = props.record || {};

    return {
      foto: record.foto || [],
      productoCompleto: record.productoCompleto,
      codBarra: record.codBarra,
      codGrupo: record.codGrupo,
      codProd: record.codProd,
      codRapido: record.codRapido,
      codSubGr: record.codSubGr,
      codUMed: record.codUMed,
      desProd: record.desProd,
      desProd2: record.desProd2,
      precioBol: record.precioBol,
      precioVta: record.precioVta,
      ean13: record.ean13,
      sku: record.sku,
      imgUrl: record.imgUrl,
      categorias: record.categorias || [],
    };
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: initialValues as any,
  });

  const onSubmit = (values) => {
    props.onSubmit(props.record?.id, values);
  };

  const onReset = () => {
    Object.keys(initialValues).forEach((key) => {
      form.setValue(key, initialValues[key]);
    });
  };

  const {saveLoading, modal} = props;

  return (
    <FormWrapper>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Grid spacing={2} container>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <ImagesFormItem
                name="foto"
                label={i18n('entities.producto.fields.foto')}
                required={false}
                storage={Storage.values.productoFoto}
                max={undefined}
              />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="productoCompleto" label={i18n('entities.producto.fields.productoCompleto')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="codBarra" label={i18n('entities.producto.fields.codBarra')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="codGrupo" label={i18n('entities.producto.fields.codGrupo')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="codProd" label={i18n('entities.producto.fields.codProd')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="codRapido" label={i18n('entities.producto.fields.codRapido')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="codSubGr" label={i18n('entities.producto.fields.codSubGr')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="codUMed" label={i18n('entities.producto.fields.codUMed')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="desProd" label={i18n('entities.producto.fields.desProd')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="desProd2" label={i18n('entities.producto.fields.desProd2')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="precioBol" label={i18n('entities.producto.fields.precioBol')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="precioVta" label={i18n('entities.producto.fields.precioVta')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="ean13" label={i18n('entities.producto.fields.ean13')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="sku" label={i18n('entities.producto.fields.sku')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <InputFormItem name="imgUrl" label={i18n('entities.producto.fields.imgUrl')} required={false} />
            </Grid>
            <Grid item lg={6} md={8} sm={12} xs={12}>
              <CategoriaProductoAutocompleteFormItem
                name="categorias"
                label={i18n('entities.producto.fields.categorias')}
                required={false}
                showCreate={!props.modal}
                mode="multiple"
              />
            </Grid>
          </Grid>
          <FormButtons
            style={{
              flexDirection: modal ? 'row-reverse' : undefined,
            }}>
            <Button
              variant="contained"
              color="primary"
              disabled={saveLoading}
              type="button"
              onClick={form.handleSubmit(onSubmit)}
              startIcon={<SaveIcon />}
              size="small">
              {i18n('common.save')}
            </Button>

            <Button disabled={saveLoading} onClick={onReset} type="button" startIcon={<UndoIcon />} size="small">
              {i18n('common.reset')}
            </Button>

            {props.onCancel ? (
              <Button
                disabled={saveLoading}
                onClick={() => props.onCancel()}
                type="button"
                startIcon={<CloseIcon />}
                size="small">
                {i18n('common.cancel')}
              </Button>
            ) : null}
          </FormButtons>
        </form>
      </FormProvider>
    </FormWrapper>
  );
}

export default ProductoForm;
